export default {"src":"/_next/static/media/applied_amount_tag.5c880966.svg","height":25,"width":92,"blurWidth":0,"blurHeight":0};